import {
  FETCH_FAQ_REQUEST,
  FETCH_FAQ_SUCCESS,
  FETCH_FAQ_FAILURE
} from '../../../Constants/actionTypes';

import { API_FAQ_QUESTION } from '../../../Constants/apiUrls';
import { fetchFAQ } from '../../../Constants/apiService'


export const fetchFaqRequest = () => ({
  type: FETCH_FAQ_REQUEST,
});

export const fetchFaqSuccess = (faqList) => ({
  type: FETCH_FAQ_SUCCESS,
  payload: faqList,
});

export const fetchFaqFailure = (error) => ({
  type: FETCH_FAQ_FAILURE,
  payload: error,
});

export const fetchFaqs = () => {
  return async(dispatch, getState) => {
    dispatch(fetchFaqRequest());

    const state = getState();
    const accessToken = state.auth.accessToken; 


      try {

        const data = await fetchFAQ(accessToken);
        dispatch(fetchFaqSuccess(data.qnaList));
        
      } catch (error) {
        let errorMessage;
        if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
            errorMessage = 'Server is currently down. Please try again later.';
        } else {
            errorMessage = error.message;
        }
        dispatch(fetchFaqFailure(errorMessage));
      }


  };
};